import { DemographicSegments, type FormSegment } from '../../../types';

export const getDemographicSegments = (segments: FormSegment[]) => {
  const initial: Record<'ageOptions' | 'genderOptions', FormSegment[]> = {
    ageOptions: [],
    genderOptions: [],
  };

  return segments.reduce((acc, segment) => {
    const hasParent = segment.parent_segment;

    if (!hasParent) return acc;

    if (segment.category === DemographicSegments.AGE) {
      acc.ageOptions.push(segment);
    } else if (segment.category === DemographicSegments.GENDER) {
      acc.genderOptions.push(segment);
    }

    return acc;
  }, initial);
};
